import React from 'react'
import { sortByName } from '../../shared/constants'
import CustomAddForm from '../version-4/MasterForms/CustomAddForm'

function AddSubcategory({ state, setState, categories }) {
  const { selectCategory, subCategoryName, description, file, subcategoryCode, active } = state
  //console.log('CAT : ', state)

  const input = [
    { label: 'Sub Category Code', value: subcategoryCode, name: 'subcategoryCode' },
    {
      label: 'Category',
      value: selectCategory,
      name: 'selectCategory',
      options: sortByName(categories, 'categoryName'),
      fieldName: 'categoryName',
      fieldValue: '_id',
    },
    { label: 'Sub Category Name', value: subCategoryName, name: 'subCategoryName' },
    { label: 'Description', value: description, name: 'description' },
    { label: 'Image', type: 'IMAGE', name: 'file' },
    { label: 'Status', value: active, name: 'active', type: 'ACTIVE', noValidate: true },
  ]

  return <CustomAddForm state={state} setState={setState} data={input} />
}

export default AddSubcategory
